import { Box } from '@mui/material';
import { RegistrationBenefitsBox } from './RegistrationBenefitsBox';
import { NoRegistrationBox } from './NoRegistrationBox';

interface RegistrationOptionBoxProps {
    type: 'withregistration' | 'noregistration';
    selected: boolean;
    onSelect: () => void;
}

export const RegistrationOptionBox: React.FC<RegistrationOptionBoxProps> = ({ type, selected, onSelect }) => {
    const isWith = type === 'withregistration';

    return (
        <Box
            onClick={onSelect}
            sx={{
                border: selected ? (isWith ? '2px solid #4caf50' : '2px solid #2196f3') : '1px solid #ccc',
                borderRadius: 2,
                p: 2,
                cursor: 'pointer',
                backgroundColor: selected ? (isWith ? '#e8f5e9' : '#e3f2fd') : '#fff',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                '&:hover': { boxShadow: 2 },
                textAlign: 'left',
                height: '100%',
            }}
        >
            {isWith ? <RegistrationBenefitsBox /> : <NoRegistrationBox />}
        </Box>
    );
};
